module.exports = __webpack_public_path__ + "img/gran-teatro-del-liceo.d0bfa059.jpg";